import { APP_MANAGED_ROUTES } from "common/app-managed-routes";
import { useNavigate } from "@leagueplatform/routing";
import { useAuth } from "@leagueplatform/auth-utils";

export const PreLoginLandingPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    navigate(APP_MANAGED_ROUTES.HOME);
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        textAlign: "center",
        maxWidth: "320px",
        flexDirection: "column",
        gap: "12px",
        margin: "32px auto",
      }}
    >
      Log into Medibank to continue
      <button
        type="button"
        onClick={() => navigate(APP_MANAGED_ROUTES.SIGN_IN)}
        style={{
          cursor: "pointer",
        }}
      >
        Login
      </button>
    </div>
  );
};
